function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21440"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19833",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17707",
    d: "M12.908 9.3H17.2a1.8 1.8 0 0 1 1.611 2.607l-3.152 6.3a1.8 1.8 0 0 1-1.612 1h-3.62a1.791 1.791 0 0 1-.437-.054l-3.39-.841m6.3-9.007V4.8A1.8 1.8 0 0 0 11.1 3h-.086a.815.815 0 0 0-.815.815 3.251 3.251 0 0 1-.548 1.807L6.6 10.206v8.106m6.3-9.007h-1.8m-4.5 9.007H4.8a1.8 1.8 0 0 1-1.8-1.8v-5.4A1.8 1.8 0 0 1 4.8 9.3h2.253",
    transform: "translate(1.5 .5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgLike;